import React from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Box, Menu, Text } from 'grommet'
import { LinkBottom, Folder, Save, FolderOpen, Analytics } from 'grommet-icons'
// import { isMobile } from 'react-device-detect'
import styled from 'styled-components'
import MenuIcon from '../MenuIcon'
import { displayLoadSaveModal } from '../../redux/modal/actions'

import { RelativeBox, AbsoluteBox } from '../Common'
import { instantSave } from '../../redux/firestore/actions'
import SpinningWheelLogo from '../Spinner/SpinningWheelLogo'
import { useToast } from '../../contextHook/toast'
import { displayNewWheelDrop } from '../../redux/modal/actions'
import { useWindowSize } from '../../hook/useWindowSize'

const NoWrapText = styled(Text)`
  white-space: pre;
`

const MenuBox = styled(Box)`
  /* width: 16rem; */
  /* flex-wrap: nowrap; */
  flex-shrink: 0;
  /* min-width: 11rem; */
`

const MenuButtonBox = styled(RelativeBox)`
  :hover {
    background-color: ${props => props.theme.global.colors.hoverBg};
  }
`

const CollapsibleBox = styled(Box)`
  @media (max-width: 900px) {
    & > span {
      display: none;
    }
    & > div:nth-child(2) {
      display: none;
    }
  }
`

const LoadSaveButton = ({
  page = 'main',
  // position = 'top',
  // currentFileKey,
  // chosenKeyName = 'currentChoicesKey',
  // badge = '',
  // padding = '12px',
  // color = 'secondary',
}) => {
  // const toolColorsPersist = useSelector(
  //   state => state.settings.wheelColors.colors,
  // )
  const { authenticated } = useSelector(state => state.auth)
  const { dataStatus, currentFileKey } = useSelector(state => state.common)
  const toast = useToast()
  const windowSize = useWindowSize()
  const dispatch = useDispatch()

  const menuItems = [
    [
      {
        label: (
          <MenuBox direction="row">
            <MenuIcon icon={<LinkBottom color="secondary" size="small" />} />
            <NoWrapText>Save</NoWrapText>
          </MenuBox>
        ),
        onClick: async () => {
          try {
            await dispatch(instantSave(page))
          } catch (error) {
            toast.warning(`Error! Can't save. ${error.message}`)
            // throw error
          }
        },
        disabled:
          !authenticated || !currentFileKey || dataStatus === 'Unchanged',
      },
      {
        label: (
          <MenuBox direction="row">
            <MenuIcon icon={<Save color="secondary" size="small" />} />
            <NoWrapText>Save List as..</NoWrapText>
          </MenuBox>
        ),
        onClick: () => {
          if (authenticated) {
            dispatch(displayLoadSaveModal({ type: 'saveList' }))
          } else {
            dispatch(displayLoadSaveModal({ type: 'requestLogin' }))
          }
        },
      },
    ],
    [
      {
        label: (
          <MenuBox direction="row">
            <MenuIcon icon={<FolderOpen color="secondary" size="small" />} />
            <NoWrapText>Open/Edit File..</NoWrapText>
          </MenuBox>
        ),
        onClick: () => {
          if (authenticated) {
            dispatch(displayLoadSaveModal({ type: 'openEditList' }))
          } else {
            dispatch(displayLoadSaveModal({ type: 'requestLogin' }))
          }
        },
      },
    ],
  ]

  const keyShown = authenticated && currentFileKey

  let icon = <Folder color="iconDarkLight" size="18px" />
  if (keyShown) {
    const label =
      currentFileKey.length === 1 ? currentFileKey : currentFileKey.substring(3)

    icon = (
      <RelativeBox
        border
        width="1.8rem"
        height="1.8rem"
        align="center"
        justify="center"
        // round
      >
        {label}
        {dataStatus === 'Modified' && (
          <AbsoluteBox
            right="-.8rem"
            top="-.3rem"
            style={{ pointerEvents: 'none' }}
          >
            <Text color="secondary" style={{ lineHeight: 0 }} size="3.2rem">
              &#x2022;
            </Text>
          </AbsoluteBox>
        )}
      </RelativeBox>
    )

    if (dataStatus === 'Saving')
      icon = <SpinningWheelLogo size="1.8rem" spaceSize=".5rem" />
  }

  if (windowSize.width <= 900) {
    menuItems.unshift([
      {
        label: (
          <MenuBox direction="row">
            <MenuIcon icon={<Analytics color="secondary" size="small" />} />
            <NoWrapText>Switch Wheel</NoWrapText>
          </MenuBox>
        ),
        onClick: async () => {
          dispatch(displayNewWheelDrop(true))
        },
      },
    ])
  }
  return (
    <MenuButtonBox alignSelf="stretch" direction="row" align="stretch">
      {/* <TipDrop content="File" position={position}> */}
      <Menu
        dropAlign={{ top: 'bottom', right: 'right' }}
        dropProps={{ stretch: false }}
        // colorB={color}
        items={menuItems}
        dropBackground="baseBackground"
        // padding={padding}
        style={{ fontWeight: 500 }}
      >
        <CollapsibleBox
          direction="row"
          gap=".8rem"
          height="100%"
          align="center"
          pad={{ horizontal: '1.5rem', vertical: '0.8rem' }}
        >
          {icon}
          <Text>File</Text>
        </CollapsibleBox>
      </Menu>
    </MenuButtonBox>
  )
}

export default LoadSaveButton
